import { render, staticRenderFns } from "./TipsOverviewPage.vue?vue&type=template&id=041adbe7&scoped=true&"
import script from "./TipsOverviewPage.vue?vue&type=script&lang=ts&"
export * from "./TipsOverviewPage.vue?vue&type=script&lang=ts&"
import style0 from "./TipsOverviewPage.vue?vue&type=style&index=0&id=041adbe7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041adbe7",
  null
  
)

export default component.exports